import { Navigate, Outlet } from 'react-router-dom';
import { getPractice } from 'library/auth';
import { PORTAL_ROUTES } from 'utils/constants';

export const PatientFormsAccessRoute = () => {
  const practiceInfo = getPractice();

  if (!practiceInfo?.patient_forms_access) {
    return <Navigate to={PORTAL_ROUTES.DASHBOARD} replace />;
  }

  return <Outlet />;
};
